export interface FeatureFlags {
  // Sample feature flag keeps compiler warnings at bay when no other feature flags are active.
  sampleFeatureFlag: boolean;
  enableBookInDigitalGuidance: boolean;
  enableETicketOptionQRCode: boolean;
  enableETicketFraudDetection: boolean;
  enableCustomTopPage: boolean;
  enableSeatManagement: boolean;
  enable3DS: boolean;
  enableCrossSellUpSell: boolean;
  enableCarrierEmailWarningAndEmailAutocomplete: boolean;
  enableCheckinStartTimeRelative: boolean;
  enableSMSTermsOfService: boolean;
  enablePushNotifications: boolean;
  enableETicketUXImprovements: boolean;
  enableFieldResponseFootprintedModal: boolean;
}

// In "development" mode, all features including those currently under development are enabled.
export const developmentFeatureFlags: FeatureFlags = {
  sampleFeatureFlag: true,
  enableBookInDigitalGuidance: true,
  enableETicketOptionQRCode: true,
  enableETicketFraudDetection: true,
  enableCustomTopPage: true,
  enableSeatManagement: true,
  enable3DS: true,
  enableCrossSellUpSell: true,
  enableCarrierEmailWarningAndEmailAutocomplete: true,
  enableCheckinStartTimeRelative: true,
  enableSMSTermsOfService: true,
  enablePushNotifications: true,
  enableETicketUXImprovements: true,
  enableFieldResponseFootprintedModal: true,
};

// In "release" mode, only features ready for production release are enabled.
export const releaseFeatureFlags: FeatureFlags = {
  sampleFeatureFlag: false,
  enableBookInDigitalGuidance: false,
  enableETicketOptionQRCode: false,
  enableETicketFraudDetection: false,
  enableCustomTopPage: true,
  enableSeatManagement: true,
  enable3DS: true,
  enableCrossSellUpSell: false,
  enableCarrierEmailWarningAndEmailAutocomplete: true,
  enableCheckinStartTimeRelative: true,
  enableSMSTermsOfService: true,
  enablePushNotifications: false,
  enableETicketUXImprovements: true,
  enableFieldResponseFootprintedModal: false,
};

// stg feature flags are not ready for release but are enabled for demo purposes in the stg environment.
// This breaks our "production is the same as staging" testing so it should be used sparingly.
export const stgDemoFeatureFlags: Partial<FeatureFlags> = {
  enableBookInDigitalGuidance: true,
  enableETicketOptionQRCode: true,
  enableCustomTopPage: true,
  enableSeatManagement: true,
  enable3DS: true,
  enableCrossSellUpSell: true,
  enableCheckinStartTimeRelative: true,
  enablePushNotifications: true,
  enableETicketUXImprovements: true,
  enableFieldResponseFootprintedModal: true,
};
